import React, { useEffect, useState } from "react";
import { getService } from "../api/client";
import { useParams, Link } from "react-router-dom";

const ServiceDetail = ({ settings, lang }) => {
    const { slug } = useParams();
    const [service, setService] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getService(slug);
                setService(response.data);
            } catch (error) {
                console.error("Failed to fetch service details:", error);
            } finally {
                setLoading(false);
            }
        };

        if (slug) fetchData();
    }, [slug]);

    const getText = (en, ar) => (lang === "en" ? en : ar);
    const t = (key) => {
        if (!settings) return "";
        const globalData = lang === "en" ? settings.en : settings.ar;
        return (globalData && globalData[key]) ? globalData[key] : "";
    };


    // if (loading) return <div className="text-center py-5">Loading...</div>; // Removed blocking loader
    if (!loading && !service) return <div className="text-center py-5">Service not found.</div>;

    return (
        <section className="py-5">
            <div className="container py-5">
                <div id="service-content" className="row justify-content-center">
                    {loading ? (
                        <div className="col-12 py-5 text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="col-lg-8">
                            <div className="text-center mb-5">
                                <div className="d-inline-block p-4 rounded-circle bg-primary bg-opacity-10 text-dark mb-4">
                                    <i className={`${service.icon} display-4`}></i>
                                </div>
                                <h1 className="fw-bold mb-4">{lang === 'en' ? service.title_en : service.title_ar}</h1>
                                <p className="lead text-muted">{lang === 'en' ? service.overview_en : service.overview_ar}</p>
                            </div>
                            <div className="card-custom bg-card">
                                <h3 className="fw-bold mb-4">{getText("Service Details", "تفاصيل الخدمة")}</h3>
                                <p>{lang === 'en' ? service.content_en : service.content_ar}</p>
                                <div className="mt-5 text-center">
                                    <Link to={`/contact?service=${service.title_en}`} className="btn btn-primary-custom btn-lg">
                                        {getText("Request This Service", "اطلب هذه الخدمة")}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default ServiceDetail;
